var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { MilestoneStopEntity, } from './milestone-stop.entity';
import { calcDeltaEta } from '../utils/functions';
var MilestoneEntity = /** @class */ (function () {
    function MilestoneEntity(args) {
        Object.assign(this, args);
    }
    MilestoneEntity.prototype.getDeltaEta = function () {
        return calcDeltaEta(this.deltaActualOrEstimated);
    };
    __decorate([
        Expose(),
        __metadata("design:type", String)
    ], MilestoneEntity.prototype, "type", void 0);
    __decorate([
        Expose(),
        __metadata("design:type", String)
    ], MilestoneEntity.prototype, "actualDateTime", void 0);
    __decorate([
        Expose(),
        __metadata("design:type", String)
    ], MilestoneEntity.prototype, "plannedDateTime", void 0);
    __decorate([
        Expose(),
        __metadata("design:type", String)
    ], MilestoneEntity.prototype, "estimateDateTime", void 0);
    __decorate([
        Expose(),
        __metadata("design:type", Number)
    ], MilestoneEntity.prototype, "deltaActualOrEstimated", void 0);
    __decorate([
        Expose(),
        Type(function () { return MilestoneStopEntity; }),
        __metadata("design:type", MilestoneStopEntity)
    ], MilestoneEntity.prototype, "stop", void 0);
    MilestoneEntity = __decorate([
        Exclude(),
        __metadata("design:paramtypes", [Object])
    ], MilestoneEntity);
    return MilestoneEntity;
}());
export { MilestoneEntity };
